export const initialstate = {
    calendarEvents: [
        {
            title: 'Atlanta Monster',
            start: new Date('2022-04-04 00:00'),
            id: '1001'
        },
        {
            title: 'My Favorite Murder',
            start: new Date('2022-04-05 00:00'),
            id: '1002'
        }
    ],
    events: [
        { title: 'Meeting', id: '1' },
        { title: 'Party', id: '2' },
        { title: 'Long Event', id: '3' },
        { title: 'Lunch', id: '4' },
        { title: 'Happy Hour', id: '5' }
    ]

};